export const Permission = {
  ManageUsers: "manage:users",
  ManageOrganizations: "manage:organizations",
  CreateTempAccessRequests: "create:temporary-access-requests",
  AutoApproveTempAccessRequests: "auto-approve:temporary-access-requests",
  IsInternalUsers: "is-internal:users",
} as const;

export type Permission = (typeof Permission)[keyof typeof Permission];
